export default __webpack_public_path__ + "static/media/cupffee.7ebe906a.png";